import React from "react";
import { Redirect } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const ProtectedRoute = ({ children }) => {
  const { currentUser, loading } = useAuth();
  const token = localStorage.getItem("token");

  // Wait until AuthContext finishes loading
  if (loading) {
    return <div className="text-center mt-5">Loading...</div>; 
  }

  const isAuthenticated = token && currentUser;

  if (!isAuthenticated) {
    if (token && !currentUser) {
      localStorage.removeItem("token");
      localStorage.removeItem("user");
    }
    // Redirect to the app login route
    return <Redirect to="/login" />;
  }

  return children;
};

export default ProtectedRoute;
